export const SvgWaveBottom = ({ waveFill, reverse }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1800"
    height="99.85"
    viewBox="0 0 1800 99.85"
    preserveAspectRatio="none"
    style={
      reverse
        ? {
            position: 'absolute',
            bottom: '-2px',
            left: '0',
            width: '100%',
            zIndex: 1,
            transform: 'scaleX(-1)',
          }
        : {
            position: 'absolute',
            bottom: '-2px',
            left: '0',
            width: '100%',
            zIndex: 1,
          }
    }
  >
    <path
      d="M1800,3.2S1516.81,139.3,845.9,59.553,0,3.2,0,3.2V99.849H1800Z"
      fill={waveFill}
    />
  </svg>
);

export const SvgWaveTop = ({ waveFill, absolute, hasPaperBackground }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1800"
    height="99.85"
    viewBox="0 0 1800 99.85"
    preserveAspectRatio="none"
    style={
      absolute
        ? {
            width: '100%',
            display: 'flex',
            position: 'absolute',
            top: '-2px',
            zIndex: 1,
            transform: 'rotate(180deg) scaleX(-1)',
          }
        : {
            width: '100%',
            display: 'flex',
            position: 'relative',
            bottom: '-2px',
          }
    }
  >
    <path
      d="M1800,3.2S1516.81,139.3,845.9,59.553,0,3.2,0,3.2V99.849H1800Z"
      fill={
        // eslint-disable-next-line no-nested-ternary
        hasPaperBackground === false
          ? 'var(--gold-2)'
          : hasPaperBackground === true
          ? 'var(--blue-2)'
          : waveFill
      }
    />
  </svg>
);

export const SvgWaveBottomStatic = ({ waveFill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1800"
    height="99.85"
    viewBox="0 0 1800 99.85"
    preserveAspectRatio="none"
    style={{
      width: '100%',
      display: 'flex',
      position: 'relative',
      bottom: '2px',
      transform: 'rotate(180deg)',
    }}
  >
    <path
      d="M1800,3.2S1516.81,139.3,845.9,59.553,0,3.2,0,3.2V99.849H1800Z"
      fill={waveFill}
    />
  </svg>
);

export const SvgWaveBottomStaticFake = ({ hasPaperBackground }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1800"
    height="99.85"
    viewBox="0 0 1800 99.85"
    preserveAspectRatio="none"
    style={{
      width: '100%',
      display: 'flex',
      position: 'relative',
      bottom: '2px',
      transform: 'rotate(180deg)',
      zIndex: 1,
    }}
  >
    {hasPaperBackground === false && (
      <defs>
        <pattern
          id="img1"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image
            href="https://www.datocms-assets.com/56612/1641694573-paper-pattern.jpg"
            x="0"
            y="0"
            width="500" // Always match the image size or rendering fails
            height="593"
          />
        </pattern>
      </defs>
    )}
    <path
      d="M1800,3.2S1516.81,139.3,845.9,59.553,0,3.2,0,3.2V99.849H1800Z"
      fill={
        hasPaperBackground === false ? 'url(#img1)' : 'var(--background-white)'
      }
    />
  </svg>
);
